// src/pages/CGU.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/CGU.css';

const CGU = () => {
    return (
        <div className="cgu-page">
            <h1>
                <Link to="/cgu">Conditions Générales d’Utilisation (CGU)</Link>
            </h1>

            <h2>1. Objet</h2>
            <p>
                Les présentes Conditions Générales d’Utilisation (ci-après « CGU ») ont pour objet de définir les modalités d’accès et d’utilisation du site Naninan, une plateforme dédiée à la promotion des événements cinématographiques, à l’information sur les sorties de films et à la publication d’avis par les utilisateurs. Le Site est édité par Africa Data Entry.
            </p>

            <h2>2. Acceptation des CGU</h2>
            <p>
                En accédant et en utilisant le Site, l’Utilisateur déclare avoir pris connaissance et accepter sans réserve l’intégralité des présentes CGU. Si l’Utilisateur n’accepte pas ces CGU, il lui est demandé de ne pas utiliser le Site.
            </p>

            <h2>3. Description des Services</h2>
            <p>
                Le Site propose notamment :
            </p>
            <ul>
                <li>La promotion d’événements cinématographiques (festivals, avant-premières, etc.).</li>
                <li>Un calendrier des sorties de films.</li>
                <li>La publication d’avis et de commentaires sur les films.</li>
            </ul>
            <p>
                Ces services sont fournis à titre informatif et collaboratif et ne sauraient engager la responsabilité de Africa Data Entry quant à l’exactitude des informations affichées.
            </p>

            <h2>4. Accès au Site</h2>
            <p>
                Le Site est accessible gratuitement à tout Utilisateur disposant d’un accès à Internet. Africa Data Entry se réserve le droit de suspendre ou de modifier le Site sans préavis.
            </p>

            <h2>5. Modalités d’Utilisation et Comportement des Utilisateurs</h2>
            <h3>5.1. Utilisation du Site</h3>
            <p>
                L’Utilisateur s’engage à utiliser le Site conformément aux présentes CGU et à la législation en vigueur. Il devra notamment ne pas tenter d’accéder à des zones non autorisées et utiliser le Site de manière respectueuse.
            </p>
            <h3>5.2. Publication de Contenus</h3>
            <p>
                L’Utilisateur est seul responsable des contenus qu’il publie. Africa Data Entry se réserve le droit de modérer ou de supprimer tout contenu jugé inapproprié.
            </p>

            <h2>6. Propriété Intellectuelle</h2>
            <p>
                Tous les éléments du Site sont protégés par le droit de la propriété intellectuelle et appartiennent à Africa Data Entry ou à des tiers autorisés.
            </p>

            <h2>7. Responsabilités</h2>
            <h3>7.1. Informations et Contenus</h3>
            <p>
                Africa Data Entry ne garantit pas l’exactitude ou la mise à jour permanente des informations publiées sur le Site.
            </p>
            <h3>7.2. Avis des Utilisateurs</h3>
            <p>
                Les avis et commentaires reflètent uniquement l’opinion de leurs auteurs.
            </p>
            <h3>7.3. Sécurité</h3>
            <p>
                Africa Data Entry met en œuvre des moyens raisonnables pour assurer la sécurité du Site, sans toutefois pouvoir garantir une sécurité absolue.
            </p>

            <h2>8. Données Personnelles et Confidentialité</h2>
            <p>
                La collecte et le traitement des données personnelles sont effectués conformément à la Politique de Confidentialité du Site.
            </p>

            <h2>9. Cookies</h2>
            <p>
                Le Site utilise des cookies pour faciliter la navigation et améliorer l’expérience utilisateur. Consultez notre politique relative aux cookies pour plus d’informations.
            </p>

            <h2>10. Liens Hypertextes</h2>
            <p>
                Le Site peut contenir des liens vers d’autres sites gérés par des tiers. Africa Data Entry n’est pas responsable du contenu de ces sites.
            </p>

            <h2>11. Modification des CGU</h2>
            <p>
                Africa Data Entry se réserve le droit de modifier ces CGU à tout moment. L’utilisation continue du Site après modification vaut acceptation des nouvelles conditions.
            </p>

            <h2>12. Droit Applicable et Juridiction</h2>
            <p>
                Les présentes CGU sont régies par le droit applicable dans le pays de domiciliation de Africa Data Entry. En cas de litige, les tribunaux compétents seront ceux de la région concernée.
            </p>

            <h2>13. Contact</h2>
            <ul>
                <li>Adresse e-mail : <a href="mailto:contact@africadataentry.com">contact@africadataentry.com</a></li>
                <li>Téléphone : <a href="tel:+22604443988">+226 04 44 39 88</a></li>
                <li>Adresse Postale : 17 BV 30065 OUAGA PISSY 10050 OUAGADOUGOU BURKINA FASO</li>
            </ul>
        </div>
    );
};

export default CGU;
